import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { DataUtil } from '../../../assets/ts/_utils';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { ChartData } from 'chart.js';
// import { Colors, Ticks } from 'chart.js/dist';
// import { bottom } from '@popperjs/core';
import { useThemeMode } from '../../../partials/layout/theme-mode/ThemeModeProvider';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

type DataPoint = {
  label: string;
  data: number[];
  fill: boolean;
  borderColor: string;
  tension: number;
};

type GameplaySummary = {
  summary: DataPoint[];
  count: number;
};



type Props = {
  gameplayData: GameplaySummary,
  header: string
};

const DashboardChart: React.FC<Props> = ({gameplayData, header}) => {

  const {mode} = useThemeMode()
  let [color, setColor] = useState('#3d3d3d');
  let [gridColor, setGridColor] = useState('#e1e1e1'); 
  useEffect(()=>{
    if(mode === 'dark'){
      setColor('#fff');
      setGridColor('#444444');
    }
    else{
      setColor('#3d3d3d');
      setGridColor('#e1e1e1');
    }
  }, [mode])

  const [graphData, setGraphData] = useState([]);
  const [count, setCount] = useState(0);

  function getPreviousNDates(n: number): string[] {
    const result: string[] = [];
    const currentDate = new Date();
  
    // Helper function to format the date as 'DD/MM' without using padStart
    function formatDate(date: Date): string {
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate().toString();
      const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1).toString();
      return `${day}/${month}`;
    }
  
    // Iterate over the last `n` days, including today
    for (let i = 0; i < n; i++) {
      result.push(formatDate(currentDate));
      currentDate.setDate(currentDate.getDate() - 1); // Go to the previous day
    }
  
    // Reverse the array so it starts from the oldest date
    return result.reverse();
  }
  

  useEffect(() => {
    if(gameplayData && gameplayData.summary && gameplayData.summary.length > 0){
      setGraphData(gameplayData.summary);
      setCount(gameplayData.count);
    }
  }, [gameplayData])

  // Define the types for your chart data
  const data: ChartData<'line', number[], string> = {
    labels: getPreviousNDates(count),
    datasets: graphData,
  };

  const options: any = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        align: 'end',
        labels: {
          color: color
        },
      },
      title: {
        display: true,
        text: header,
        position: 'bottom',
        align: 'center',
        color: color
      },
    },
    color: color,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value, index, ticks) {
              return DataUtil.formatNumber(value);
          },
          color: color,
        },
        grid: {
          color: gridColor
        }
      },
      x: {
        ticks: {
          color: color,
        },
        grid: {
          color: gridColor
        }
      }
    }
  };
  
  return <Line data={data} options={options} />;
};

export default DashboardChart;
